// extracted by mini-css-extract-plugin
export var active = "_2s-9";
export var backButton = "_2s-8";
export var clone = "_2s-e";
export var collapseBar = "_2s-k";
export var collapseMode = "_2s-m";
export var collapsed = "_2s-o";
export var dimmed = "_2s-i";
export var dragHandle = "_2s-c";
export var dropdownIcon = "_2s-g";
export var expanding = "_2s-n";
export var hidden = "_2s-x";
export var iconContainer = "_2s-q";
export var iconSwapper = "_2s-w";
export var navItem = "_2s-6";
export var navItemIcon = "_2s-f";
export var navProfile = "_2s-7";
export var notificationCountBadge = "_2s-j";
export var notificationDot = "_2s-r";
export var optionsContainer = "_2s-h";
export var primaryNav = "_2s-0";
export var primaryNavDivider = "_2s-v";
export var primaryNavResizeHandle = "_2s-2";
export var primaryNavResizing = "_2s-1";
export var primaryNavTabSection = "_2s-u";
export var primaryTab = "_2s-p";
export var primaryTabIconBox = "_2s-s";
export var secondaryNav = "_2s-3";
export var selected = "_2s-t";
export var settingsNav = "_2s-4";
export var settingsNavItems = "_2s-5";
export var show = "_2s-d";
export var sideNav = "_2s-l";
export var teamItem = "_2s-a";
export var userProfileItem = "_2s-b";